import { render, staticRenderFns } from "./Infoten.vue?vue&type=template&id=08e1aaea&"
import script from "./Infoten.vue?vue&type=script&lang=js&"
export * from "./Infoten.vue?vue&type=script&lang=js&"
import style0 from "./Infoten.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/administrador/developments/dtouch/dtouch-client/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib'
import { VRow } from 'vuetify/lib'
installComponents(component, {VCol,VRow})
